var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.077 52.077",
    style: {
      enableBackground: "new 0 0 52.077 52.077"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.039,7c0-4.596-12.577-7-25-7s-25,2.404-25,7c0,1.042,0.651,1.969,1.796,2.783l17.204,23.54v17.528 c0,0.43,0.256,0.813,0.652,0.979l0.686,0.246l10.662-10.663v-8.087L49.224,9.809l-0.001-0.012C50.379,8.98,51.039,8.047,51.039,7z  M26.039,2c14.04,0,23,2.961,23,5c0,0.422-0.404,0.883-1.135,1.349l-0.051-0.006l0.017,0.027C45.033,10.151,37.133,12,26.039,12 C14.934,12,7.029,10.148,4.2,8.365l0.017-0.027L3.805,8.093C3.314,7.715,3.039,7.344,3.039,7C3.039,4.961,11.999,2,26.039,2z  M30.039,40.586l-8,8V34h8V40.586z M30.533,32h-8.987L6.615,11.567C11.438,13.174,18.763,14,26.039,14 c7.276,0,14.6-0.826,19.424-2.432L30.533,32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.8e490ede093658a231890c5ca4b1dd68.svg";
export { ForwardRef as ReactComponent };